<div *ngIf="reactiveFormGroup$ | async" [formGroup]="reactiveFormGroupComponent?.getReactiveFormGroup()">
  <app-odata-typeahead-search
    [odataFunction]="odataFunction"
    placeHolder="Search by name or member ID"
    i18n-placeHolder
    [disabled]="!!selectedMember || disabled"
    [displayValueInline]="true"
    [customItemTemplate]="lookAheadItemTemplate"
    [popperClass]="'look-ahead-popper-full-width'"
    [hasErrors]="hasErrors$ | async"
    [clearSearchTrigger]="clearSearchTrigger"
    (lookAheadCleared)="memberSelected.emit(undefined)"
    (lookAheadSelected)="memberSelected.emit($event)" />
  <lib-reactive-form-general-error
    [parentFormGroupComponent]="reactiveFormGroupComponent"
    [reactiveFormItemComponent]="this"
    [required]="required"
    [disabled]="disableInput$ | async"
    [performValidationWhenDisabled]="performValidationWhenDisabled"
    (hasError)="connectToHasErrors($event)" />
  <input hidden [formControlName]="inputName" [id]="id" [name]="inputName" />
</div>

<ng-template #lookAheadItemTemplate let-member>{{ member.name }} ({{ member.id }}) </ng-template>
